module.exports = __webpack_public_path__ + "static/media/winda.6f999c6e.jpg";